define([
    'edge/platform/widgets/accordion/collapse/directives/collapse',
    'edge/platform/widgets/accordion/transition/module'
], (collapse)=> {
    return angular.module('edge.platform.widgets.ui.bootstrap.collapse', [
        'edge.platform.widgets.ui.bootstrap.transition'
    ])
        .directive('gwPlCollapse', collapse);
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/accordion/collapse/module.js